import React from 'react';
import { get, some } from 'lodash';
import { Field } from 'redux-form';
import { dictionariesSchema } from '../../../../common/constants/dictionaries';
import hasAccess, { chargerStatusSelectAccessId } from '../../../../common/services/HasAccess';
import RenderSelect from '../../../../common/components/Form/RenderSelect';
import { isPending } from '../../../../common/services/ValidationRules';
import { getCountryByCode } from '../../../AdminTools/components/CountryUtils';
import { StatusLabel } from '../../../../common/constants/CommonUsedDropdownsStatics';

export const isReadOnlyChargerSelectField = (field, props) => {
  const {
    user: { currentPermissions },
  } = props;
  const noAccess = !hasAccess(chargerStatusSelectAccessId, currentPermissions);
  const connector = field.name.includes('p_status') && noAccess;
  const fromMonitoredToAvailable = field.name === 'i2p2_state.c_status' && noAccess;

  return field.readOnly || fromMonitoredToAvailable || connector || field.isUnknownValue;
};

const renderReadOnlySelectForStatus = (field, inner) =>
  field.isUnknownValue &&
  (field.name === 'i2p2_state.c_status' || (field.name.indexOf === '.p_status') !== -1 || field.name === 'charger_state') ? (
    <StatusLabel status="unknown" />
  ) : (
    inner
  );

const renderReadOnlySelect = (field, props) => {
  const { currentChargerData } = props;
  const name = get(currentChargerData, field.name);
  const value = field.name === 'c_identity.c_country' ? getCountryByCode(name) : name;
  const children = get(field, 'children');
  let inner = field.isUnknownValue ? 'Unknown' : value;

  if (children && !field.isUnknownValue) {
    const selected = field.children.find((child) => child.value === value);

    inner = get(selected, 'label', '');
  }

  return (
    <div className="staticField" key={field.name}>
      <div className="label">
        {field.floatingLabelText}
        <div className="value">{renderReadOnlySelectForStatus(field, inner)}</div>
      </div>
    </div>
  );
};

export const renderEditableSelectField = (field, props) => {
  const { dictionaries, change } = props;
  // Find field in schema
  const dictionary = dictionariesSchema.find((dic) => dic.field === field.name);
  const filterChildFields = (item, dictionary) => {
    const { dictionaries } = props;
    // Filter fields by parent
    // Find parent in schema
    const parentDicSchema = dictionariesSchema.find((dic) => dic.field === dictionary.parent);

    // If field has parent
    if (parentDicSchema) {
      // Find parent in dictionary
      const parent = dictionaries[parentDicSchema.name].find((row) => row.value === props[dictionary.parent]);

      if (parent) {
        return parent.uuid === item.parent_id;
      }

      return false;
    }

    return true;
  };

  let dicChildren = null;

  // If it is dictionary field
  if (dictionary && dictionaries && dictionary.name && get(dictionaries, dictionary.name)) {
    dicChildren = props.dictionaries[dictionary.name]
      .filter((item) => filterChildFields(item, dictionary))
      .map((row) =>
        dictionary.name === 'COUNTRY'
          ? { value: row.code, label: row.value }
          : {
              value: row.value,
              label: row.value,
            },
      );
    if (props.c_country && !some(dicChildren, ['value', props.c_country]) && dictionary.name === 'COUNTRY') {
      dicChildren.push({ value: props.c_country, label: getCountryByCode(props.c_country) });
    }
  }

  const onChange = () => {
    if (field.name === 'c_identity.c_country') {
      change('c_identity.c_address', null);
      change('c_identity.c_latitude', null);
      change('c_identity.c_longitude', null);
      change('c_identity.c_utc', null);
    }
  };

  // Task https://iotecha.atlassian.net/browse/I2P2-13140
  // If status is pending and address is filled, we should validate Charger Condition to Active
  // maybe not a best solution
  const value = get(props.formValues, field.name);
  const isNotEmptyAddressValue = Boolean((get(props, 'c_address') || '').trim());
  const addressFieldFirst = value === 'pending' && field.addressIsRequired && isNotEmptyAddressValue;

  const required = addressFieldFirst || field.starred;
  let validate = field.validate;

  if (addressFieldFirst) {
    validate = [...field.validate, isPending];
  }

  return (
    <Field
      {...field}
      key={field.name}
      required={required}
      component={RenderSelect}
      onChange={onChange}
      validate={validate}
      fullWidth
      options={dicChildren || field.children}
    />
  );
};

export const renderSelectField = (field, props) => {
  const isReadOnly = isReadOnlyChargerSelectField(field, props);

  return isReadOnly ? renderReadOnlySelect(field, props) : renderEditableSelectField(field, props);
};
